import React from "react"
import RechargeDocuments from "components/RechargeDocuments"

const RechargeDocumentsPage = () => <RechargeDocuments />

export default RechargeDocumentsPage



// WEBPACK FOOTER //
// ./src/scenes/RechargeDocuments/index.js